// extracted by mini-css-extract-plugin
module.exports = {"repayButtonBox":"repayButtons_repayButtonBox__wqiiO","payCommonButton":"repayButtons_payCommonButton__GwiS8","payError":"repayButtons_payError__DgVmT"};